import axios from 'axios';

const environment = {
  local: {
    api: process.env.REACT_APP_API_URL_LOCAL,
    voucherApi: process.env.REACT_APP_API_VOUCHER_URL_LOCAL,
    inventory2Api: process.env.REACT_APP_INVENTORY2_API_URL_LOCAL || 'http://localhost:3001',
  },
  production: {
    api: process.env.REACT_APP_API_URL,
    voucherApi: process.env.REACT_APP_API_VOUCHER_URL,
    inventory2Api: process.env.REACT_APP_INVENTORY2_API_URL || 'https://corteva-ai.webcol.systems/',
  },
  import: {
    api: process.env.REACT_APP_API_IMPORT_URL,
  },
};

const baseURL =
  process.env.NODE_ENV === 'development'
    ? environment.local
    : environment.production;

const BaseURLImport = environment.import;

export const showProductionApiAlert =
  process.env.NODE_ENV === 'development' && baseURL === environment.production;

export const api = axios.create({
  baseURL: baseURL.api,
  headers: {},
  withCredentials: true,
});

export const voucherApi = axios.create({
  baseURL: baseURL.voucherApi,
  headers: {},
  withCredentials: true,
});

export const importApi = axios.create({
  baseURL: BaseURLImport.api,
  headers: {},
});

const inventory2ApiKey = process.env.REACT_APP_INVENTORY2_API_KEY;

export const inventory2Api = axios.create({
  baseURL: baseURL.inventory2Api,
  headers: {
    ...(inventory2ApiKey && { 'x-api-key': inventory2ApiKey }),
  },
});

export const dashboardUrl = `https://webcol-dashboard.webcol.systems`;

export const apiDashboard = axios.create({
  baseURL: dashboardUrl,
  headers: {},
  withCredentials: true,
});

export const applyQueryString = (
  url: string,
  payload: Record<string, any>
): string => {
  const validObject: Record<string, any> = {};

  if ('dirty' in payload) {
    delete payload.dirty;
  }

  for (const [param, value] of Object.entries(payload)) {
    if (value) Object.assign(validObject, { [param]: value });
  }

  if (Object.keys(validObject).length === 0) {
    return url;
  }

  const searchParams = new URLSearchParams(validObject).toString();

  return `${url}?${searchParams}`;
};

export const formDataBuilder = (payload: Record<string, any>): FormData => {
  const formData = new FormData();

  for (const [param, value] of Object.entries(payload)) {
    if (value instanceof File) {
      formData.append(param, value, value.name);
    } else if (value instanceof FileList) {
      for (let i = 0; i < value.length; i++) {
        formData.append(`${param}[]`, value[i], value[i].name);
      }
    } else if (value instanceof Array) {
      value.forEach((val, index) => {
        if (val instanceof File) {
          return formData.append(`${param}[${index}]`, val, val.name);
        } else if (val instanceof Object) {
          return Object.entries(val).forEach(([key, value]: any) => {
            formData.append(`${param}[${index}].${key}`, value);
          });
        }

        formData.append(`${param}[]`, value[index]);
      });
    } else if (value) {
      formData.append(param, value);
    }
  }

  return formData;
};

export const handleApiError = (error: any): Error => {
  const errorCode = error?.response?.data?.code;
  const errorMessage = error?.response?.data?.message || error?.message;

  const refinedErrorMessage = (() => {
    if (!errorCode) return errorMessage;
    return errorMessage.replace(`${errorCode}: `, '');
  })();

  return new Error(refinedErrorMessage);
};
